export default __webpack_public_path__ + "static/media/Automation.3162d290.jpeg";